import { render, staticRenderFns } from "./link.vue?vue&type=template&id=24582404&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"
import style0 from "./link.vue?vue&type=style&index=0&id=24582404&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24582404",
  null
  
)

export default component.exports